import API_URLS from '../../constants/api-urls';
import { FOLDER_DIRECTORIES } from '../../constants/folder';
import axios from '../../utils/axios';

type ArchiveMaterialsArgs = {
    directory: FOLDER_DIRECTORIES;
    materialIds: number[];
};

export const archiveMaterials = ({ materialIds, directory }: ArchiveMaterialsArgs) => {
    const queryFilter = `{in: {id: [${materialIds.toString()}] }}`;

    return axios.post(`${API_URLS.FOLDERS.ARCHIVE}`, {
        queryFilter,
        type: directory
    });
};

export const unarchiveMaterials = ({ materialIds, directory }: ArchiveMaterialsArgs) => {
    const queryFilter = `{in: {id: [${materialIds.toString()}] }}`;

    return axios.post(`${API_URLS.FOLDERS.UNARCHIVE}`, {
        queryFilter,
        type: directory
    });
};
